// src/modules/app-views/invoices/components/InvoiceFilterDrawerBody.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Divider, Select } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const NATURE_OPTIONS = [
  { value: 'sale', labelKey: 'sale' },
  { value: 'return', labelKey: 'return' },
  { value: 'transfer', labelKey: 'transfer' },
  { value: 'bonus', labelKey: 'bonus' },
  { value: 'demo', labelKey: 'demo' },
  { value: 'sample', labelKey: 'sample' },
  { value: 'consignment', labelKey: 'consignment' },
  { value: 'other', labelKey: 'other' },
];

const OPERATION_TYPE_OPTIONS = [
  { value: 'exit', labelKey: 'operation_exit' },
  { value: 'entry', labelKey: 'operation_entry' },
];

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const InvoiceFilterDrawerBody = ({ listContext }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const setDrawerFilter = listContext?.setDrawerFilter;
  const setFilter = listContext?.setFilter;
  const drawerState = listContext?.query?.drawer;

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleOperationNatureChange = value => {
    setDrawerFilter?.({ operationNature: value ?? null });
    setFilter?.('operationNature', value != null ? [value] : undefined);
  };

  const handleOperationTypeChange = value => {
    setDrawerFilter?.({ operationType: value ?? null });
    setFilter?.('operationType', value != null ? [value] : undefined);
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div>
      <Divider dashed />

      <h5 className="mb-3 text-muted">{translateX('filters')}</h5>

      <div className="mb-3">
        <div className="text-muted small mb-1">{translateX('nature')}</div>
        <Select
          allowClear
          className="w-100"
          value={drawerState?.operationNature ?? undefined}
          onChange={handleOperationNatureChange}
          options={NATURE_OPTIONS.map(o => ({ value: o.value, label: translateX(o.labelKey) }))}
          placeholder={translateX('nature')}
        />
      </div>

      <div className="mb-3">
        <div className="text-muted small mb-1">{translateX('operation')}</div>
        <Select
          allowClear
          className="w-100"
          value={drawerState?.operationType ?? undefined}
          onChange={handleOperationTypeChange}
          options={OPERATION_TYPE_OPTIONS.map(o => ({
            value: o.value,
            label: translateX(o.labelKey),
          }))}
          placeholder={translateX('operation')}
        />
      </div>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default InvoiceFilterDrawerBody;

